import React, { useEffect } from 'react';
import Article from '@pages/newsroom/article';
import { startLazyLoad } from '@services/lazy-load';

/**
 * Article Props.
 */
type ArticleProps = {
  title: string;
  date_release: string;
  node_alias: string;
  widen_image_id: string;
  description: string;
  summary: string;
  category_id?: string;
};

/**
 * Get Blog Category.
 */
const getBlogCategory = (categoryId: string): string => {
  let category = '';
  switch (categoryId) {
    case '168':
      category = 'Centerline';
      break;
    case '169':
      category = 'SpotOn';
      break;
    case '758':
      category = 'VISion';
      break;
  }
  return category;
};

/**
 * Check if article is featured.
 */
const isFeaturedArticle = (
  imageId: string,
  index: number,
  pageNum: number | string,
  pageType?: string
): boolean => {
  if (
    imageId &&
    index === 0 &&
    (pageNum === 1 || pageNum === '') &&
    pageType !== 'homepage'
  ) {
    return true;
  }
  return false;
};

/**
 * Newsroom Articles.
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const ArticleList: React.FC<{
  articleList: ArticleProps[];
  activePage: string | number;
  pageType?: string;
  newsroomCategory: string;
}> = ({ articleList, activePage, pageType, newsroomCategory }) => {
  /**
   * LazyLoad
   */
  useEffect(() => {
    setTimeout(() => {
      startLazyLoad();
    }, 0);
  }, [activePage]);

  /**
   * Render
   */
  if (articleList && articleList.length > 0) {
    return articleList.map((article, index) => {
      const {
        title,
        date_release: releaseDate,
        node_alias: url,
        widen_image_id: imageId,
        description,
        summary,
        category_id: categoryId,
      } = article;

      const featured = isFeaturedArticle(imageId, index, activePage, pageType);
      const blogCategory = categoryId ? getBlogCategory(categoryId) : '';

      return (
        <Article
          title={title}
          releaseDate={releaseDate}
          url={url}
          imageId={imageId}
          body={description}
          summary={summary}
          featured={featured}
          category={newsroomCategory}
          blogCategory={blogCategory}
          key={index}
        />
      );
    });
  }
  return null;
};

export default ArticleList;
